<style scoped lang="scss">
    .reply {
        .owner-name {
            font-size: 1.1em;
            font-weight: bold;
        }
    }

    .reply-container {
        background-color: #eee;
        padding: 20px;
        textarea {
            background-color: #fff;
        }
    }
</style>

<template>
    <div>
        <div class="uk-grid" v-if="message && user">
            <div class="uk-width-8-10 uk-align-center">
                <a href="javascript:;" @click="$router.replace('/inbox')">
                    <i class="uk-icon-backward"></i>
                    Back to All Messages
                </a>
            </div>

            <div class="uk-width-8-10 uk-align-center">
                <h3 class="communication-direction-text uk-text-lead uk-text-center">
                <span class="uk-float-left">
                    MESSAGE #{{ message.id }}
                </span>
                </h3>
            </div>
            <hr class="uk-width-8-10 uk-align-center dashed-hr uk-margin-bottom"/>

            <div class="uk-width-8-10 uk-align-center uk-grid uk-padding-remove">
                <div class="uk-width-medium-1-3 uk-width-small-1-1 communication-type-and-who">
                    <span class=" communication-item-date-time">
                        <span class="uk-text-muted">Date:</span>  <br>
                        {{ message.created_at | moment('MM/DD/YYYY h:m a')}}
                    </span>
                </div>
                <br class="print-only">
                <div class="uk-width-medium-1-3 uk-width-small-1-1 communication-item-excerpt uk-margin-bottom">
                    <span class="uk-text-muted">From: </span> <br>
                    {{ message.owner.name }}
                </div>
                <br class="print-only">
                <div class="uk-width-medium-1-3 uk-width-small-1-1 communication-item-tt-to-from">
                    <span class="uk-text-muted">To: </span> <br>
                    <span v-for="recipient in message.recipients">
                        {{ recipient.user.name }}
                        <i
                            :class="{'a-envelope-4': !isRead, 'a-envelope-open_1': isRead}"
                            uk-tooltip="pos:top-left;title:Not viewed yet"
                            title="" aria-expanded="false"></i>,
                    </span>
                </div>
            </div>

            <div class="uk-width-medium-8-10 uk-align-center uk-grid uk-padding-remove uk-margin-top-remove">

                <div class="uk-width-1-1"><!--used to be uk-width-9-10, but Linda changed it-->
                    <div uk-grid="" class="uk-grid-collapse uk-grid">
                        <div class="uk-width-1-6 uk-margin-bottom">
                            <span class="uk-text-muted">Subject: </span>
                        </div>
                        <div class="uk-width-5-6 uk-text-left uk-margin-bottom">
                            <strong>{{ message.subject }}</strong><br>
                        </div>
                        <br class="print-only">
                        <div class="uk-width-1-6 uk-margin-bottom">
                            <span class="uk-text-muted">Message: </span>
                        </div>
                        <div class="uk-width-5-6">
                            <div><p>{{ message.message }}</p></div>
                        </div>
                    </div>
                </div>

            </div>

            <hr class="uk-width-8-10 uk-align-center dashed-hr uk-margin-bottom" />
            <div class="uk-width-8-10 uk-align-center">
                <h3 class="communication-direction-text uk-text-lead uk-text-center">
                        <span class="uk-float-left" v-if="message.replies.length > 0">
                            REPLIES ({{ message.replies.length }})
                        </span>
                        <span class="uk-float-left" v-else>
                            NO REPLIES
                        </span>
                </h3>
            </div>
            <div class="uk-margin-top uk-width-8-10 uk-align-center" v-if="message && user">
                <div v-for="reply in message.replies"
                     class="reply uk-width-1-1 communication-list-item normal-cursor uk-margin-large-bottom">
                    <div uk-grid="" class="communication-summary uk-grid">
                        <div class="uk-width-medium-1-5 uk-width-small-1-1 communication-type-and-who">
                            <span class="owner-name">{{ reply.owner.name }}<br></span>
                            <span class=" communication-item-date-time">
                            {{ reply.created_at | moment('MM/DD/YYYY h:m a')}}
                        </span>
                        </div>
                        <div class="uk-width-medium-4-5 uk-width-small-1-1 communication-item-excerpt">
                            <p>{{ reply.message }}</p>
                        </div>
                        <div class="uk-width-1-1 uk-width-2-5@s">
                        </div>
                        <hr class="print-only">
                    </div>
                </div>
            </div>
            <hr class="uk-width-8-10 uk-align-center dashed-hr" />
            <div class="uk-width-8-10 uk-align-center reply-container" >
                <form @submit.stop="submitReply" class="uk-form uk-form-horizontal">
                    <div class="uk-form-row">
                        <label class="uk-form-label">Reply</label>
                        <div class="uk-form-controls">
                          <textarea class="uk-width-1-1 uk-input"
                                    v-model="replyBody"
                                    placeholder="Add your reply here..."></textarea>
                        </div>
                    </div>
                    <div class="uk-form-row">
                        <button class="uk-button uk-button-primary uk-align-right">Submit Reply</button>
                    </div>
                </form>

            </div>
        </div>
    </div>

</template>

<script>
    import MessageListItem from "../../components/Messages/MessageListItem";
    export default {
        name: "MessageDetails",
        components: {MessageListItem},
        props: {
            id: {
                default: null,
            },
            highlightReply: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                message: null,
                user: {},
                replyBody: '',
                replyLoading: false,
                formErrors: null,
            }
        },
        computed: {
            isRead() {
                let isRead = false;
                if(this.message.owner_id === this.user.id) {
                    isRead = true;
                };
                for(var i in this.message.recipients) {
                    if(this.message.recipients[i].user_id === this.user.id && this.message.recipients[i].seen_at !== null) {
                        isRead = true;
                    };
                }

                // Check Replies
                _.each(this.message.replies, reply => {
                    _.each(reply.recipients, recipient => {
                        if(recipient.user_id == this.user.id && recipient.seen_at === null) {
                            isRead = false;
                        }
                    })
                })

                return isRead;
            },
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                axios.get('/api/hope/me').then(r => {
                    this.user = r.data.user;
                })
                axios.get('/api/hope/communications/'+this.id).then(r => {
                    this.message = r.data.communication;
                })
            },
            onMessageUpdated($event) {

            },
            submitReply($event) {
                this.replyLoading = true;
                axios.post(`/api/hope/communications/${this.id}/reply`, {
                    message: this.replyBody,
                })
                    .then(r => {
                        this.replyLoading = false;
                        this.replyBody = '';
                        this.getData();
                    })
                    .catch(err => {
                        this.replyLoading = false;
                        this.formErrors = err.response.data.errors;
                    })
            }
        }
    }
</script>
